export enum CallState {
  Accept = "Accept",
  Progress = "Progress",
  Redirect = "Redirect",
  Reject = "Reject",
  Trying = "Trying"
}
